import { Component } from "react";
import Toolbar from "../components/toolbar";
import { dbAdmin, dbPublic } from "../../App";
import { MdAddBox } from "react-icons/md";
import { addDoc, collection, deleteDoc, getDocs, orderBy, query, Timestamp, updateDoc } from "firebase/firestore/lite";
import { FaEdit, FaTrash } from "react-icons/fa";
import { CgCloseO } from "react-icons/cg";
import { ImCheckmark } from "react-icons/im";
import { TiCancel } from "react-icons/ti";

class Testimonials extends Component<any,any> {

    constructor(props:any)
    {
        super(props);
        this.state={
            testimonials: [],
            testimonial: {},
            testimonialDoc: {},
            updating: false,
        }
    }

    async componentDidMount() {
        var tCol = collection(dbPublic,'testimonials');
        var tSnap = getDocs(query(tCol,orderBy("date",'desc'))).then(tSnap => {
            this.setState({testimonials: tSnap.docs});
        });
    }

    render() {
        return (
        <div style={{height: '100%', fontFamily: 'avenir'}}>
            <Toolbar />
            <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                    TESTIMONIALS
                </div>
                <div>
                    <div style={{fontFamily: 'avenirb'}}></div>
                    Add or edit testimonials displayed on the website.<br/><br/>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                        this.setState({updating: true});
                    }}><MdAddBox style={{color: 'rgba(0,200,0,1)'}} size={30} /> NEW TESTIMONIAL</div>
                    <br/>
                </div>
                <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                    <div style={{width: '200px'}}><b>Date</b></div>
                    <div style={{width: '200px'}}><b>Testimonial By</b></div>
                    <div style={{width: '200px'}}><b>Region</b></div>
                    <div style={{width: '200px'}}><b>Testimonial</b></div>
                    <div style={{width: '200px'}}><b>Image</b></div>
                    <div style={{width: '200px'}}></div>
                </div>
                {this.state.testimonials.map((t:any,i:number)=>{
                    var d = t.data();
                    
                    return (
                        <div key={i} style={{fontSize: '10pt',display: 'flex',marginTop: '10px',paddingBottom: '10px',borderBottom: '1px solid rgba(0,0,0,.2)'}}>
                            <div style={{width: '200px'}}>{new Date(d.date.seconds * 1000).toLocaleString()}</div>
                            <div style={{width: '200px'}}>{d.name}</div>
                            <div style={{width: '200px'}}>{d.region}</div>
                            <div style={{width: '200px'}}>{d.testimonial}</div>
                            <div style={{width: '200px'}}>{d.picture != '' ? <img src={d.picture} style={{borderRadius: 10, width: '200px', height: '200px', objectFit: 'cover' }} /> : <img src="/content/images/nopicture.png" style={{width: '200px', height: '200px', objectFit: 'cover', borderRadius: 10 }} />}</div>
                            <div style={{width: '200px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                                
                                <FaEdit size={25} style={{marginRight: '30px', cursor: 'pointer'}} onClick={()=>{
                                    this.setState({updating: true, testimonial: d, testimonialDoc: t});
                                }}/>

                                <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                    var tCol = collection(dbPublic,'testimonials');
                                    await deleteDoc(t.ref);
                                    var tSnap = await getDocs(query(tCol,orderBy("date",'desc')));
                                    this.setState({testimonials: tSnap.docs});
                                }}/>
                            </div>
                        </div>
                    );
                })}

            {this.state.updating ?
            <div className="overlay" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div className="window" style={{height: 'auto', maxHeight: 'none',}}>
                    <div className="closeWindow" onClick={()=>{
                        this.setState({updating: false, testimonial: {}, testimonialDoc: {}});
                    }}>
                        <CgCloseO />
                    </div>
                    <div className="windowTitle">
                        ADD/EDIT TESTIMONIAL
                    </div>
                    <div>
                        Add or update an existing testimonial.  When finished, click the save button to confirm.
                    </div>

                    <div className="formStyle">
                        <div className="label">
                            Date
                        </div>
                        <div className="input" >
                            <input type="datetime-local" style={{backgroundColor: 'rgba(0,0,0,.1)'}} required name="date" disabled value={this.state.testimonial.date != null ? new Date(this.state.testimonial.date.seconds * 1000 - ((1000 * 60) * (new Date().getTimezoneOffset() + 60))).toISOString().replace("Z","") : new Date(new Date().getTime() - ((1000 * 60) * (new Date().getTimezoneOffset()))).toISOString().replace("Z","")} />
                        </div>
                        
                        <div style={{display: 'flex', marginTop: '20px', position: 'relative'}}>
                        <div className="label noOffset">
                            Testimonial By
                        </div>
                        <div className="input">
                            <input type="text" required name="by" defaultValue={this.state.testimonial.name} />
                        </div>
                        <div className="label" style={{top: '0px', left: '40px'}}>
                            Region
                        </div>
                        <div className="input">
                            <input type="text" required name="region" defaultValue={this.state.testimonial.region} />
                        </div>
                        </div>
                        <div className="label">
                            Testimonial
                        </div>
                        <div className="input">
                            <textarea required name="testimonial" defaultValue={this.state.testimonial.testimonial} style={{width: '95%'}} rows={5} />
                        </div>
                        <div className="label">
                            Replace Picture
                        </div>
                        <div className="input">
                            <input required type="file" name="picture" style={{width: '95%'}} onChange={(e:React.ChangeEvent<HTMLInputElement>)=>{
                                const fd = new FormData();
                                if (e.target.files)
                                {
                                    console.log(e.target.files[0]);
                                    //e.target.files[0].stream().getReader().read().then((v)=>{
                                    //    console.log(v.value);
                                        var x = new FileReader();
                                        x.onload = (a) => {
                                            //console.log(a.target?.result);
                                            var t1 = this.state.testimonial;
                                            t1.picture = a.target?.result;
                                            this.setState({testimonial: t1});
                                        }
                                        x.readAsDataURL(e.target.files[0]);
                                    //})
                                }
                            }} />
                        </div>
                        <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '300px'}}>
                        <img src={this.state.testimonial.picture ? this.state.testimonial.picture : "/content/images/nopicture.png"} style={{width: '200px', height: '200px', objectFit: 'contain' }} />
                        </div>

                        <div className="buttons">
                            <button className="cancelButton" onClick={()=>{
                                this.setState({updating: false, testimonial: {}, testimonialDoc: {}});
                            }}><TiCancel /> CANCEL</button>
                            <button className="acceptButton" onClick={async ()=>{
                                    var tCol = collection(dbPublic,'testimonials');
                                if (this.state.testimonial.date)
                                {
                                    // update user
                                    await updateDoc(this.state.testimonialDoc.ref,{name: (document.getElementsByName("by")[0] as HTMLInputElement).value,
                                                            region: (document.getElementsByName("region")[0] as HTMLInputElement).value,
                                                            testimonial: (document.getElementsByName("testimonial")[0] as HTMLInputElement).value,
                                                            picture: this.state.testimonial.picture});
                                } else {
                                    // create new user
                                    
                                    await addDoc(tCol,{
                                        
                                        date: Timestamp.fromDate(new Date()),
                                        name: (document.getElementsByName("by")[0] as HTMLInputElement).value,
                                        region: (document.getElementsByName("region")[0] as HTMLInputElement).value,
                                        testimonial: (document.getElementsByName("testimonial")[0] as HTMLInputElement).value,
                                        picture: this.state.testimonial.picture ? this.state.testimonial.picture : ''});
                                }
                                var tSnap = await getDocs(query(tCol,orderBy("date",'desc')));
                    
                                this.setState({updating: false, testimonial: {}, testimonialDoc: {},testimonials: tSnap.docs});
                            }} ><ImCheckmark /> CONFIRM</button>
                        </div>
                    </div>

                </div>
            </div> : null }
            </section>
        </div>
        );
    }
}

export default Testimonials;